// App.js - Composant principal
import React, { useState, useEffect } from 'react';

import InvoiceDashboard from '../Dashboard/InvoiceDashboard';
import SidebarADM from '../components/Sidebar/SidebarADM';
import NavbarADM from '../components/Navbar/NavbarADM';


function MyInvoicesPagesADM({tel}) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
 

  // Détection de la taille d'écran pour le mode mobile
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="app">
      <SidebarADM
        isOpen={sidebarOpen} 
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />
      <div className="main-content">
        <NavbarADM
          tel={tel}
          toggleSidebar={toggleSidebar}
          isMobile={isMobile}
        />
        <InvoiceDashboard tel={tel}  />
         
      
      </div>
    </div>
  );
}

export default MyInvoicesPagesADM;